module.exports = __webpack_public_path__ + "static/media/2_en.c1f9bd6f.png";